import { render, staticRenderFns } from "./IconStatusSuccessful.vue?vue&type=template&id=48c35558&"
import script from "./IconStatusSuccessful.vue?vue&type=script&lang=ts&"
export * from "./IconStatusSuccessful.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports